const AboutVision = ({ data }) => {
  return (
    <div className="vision-stage-container">
      <div className="vision-stage-logo">
        <img src={data?.src} alt={data?.alt} />
      </div>
      <div className="vision-stage-title">{data?.title}</div>
      <div className="vision-stage-desc">{data?.description}</div>
    </div>
  );
};

export default AboutVision;
